<template>
  <f7-popup
    v-model:opened="opened"
    class="main-pc-map-popup"
    close-on-escape
  >
    <f7-page>
      <template #fixed>
        <TheNavbar
          :nav-title="popupTitle"
          class="at-navbar secondary-navbar"
          :popup-close-btn-enable="true"
        />
      </template>

      <div v-if="opened">
        <UCGoogleMap
          :latitude="latitude"
          :longitude="longitude"
        />
      </div>
    </f7-page>
  </f7-popup>
</template>

<script setup>
// @ts-check
import TheNavbar from '@/components/TheNavbar.vue';
import UCGoogleMap from './UCGoogleMap.vue';

defineProps({
  /** The title for the popup. */
  popupTitle: { type: String, default: 'Mapa' },
  /** The latitude coordinate for the map center. */
  latitude: { type: Number, required: true },
  /** The longitude coordinate for the map center. */
  longitude: { type: Number, required: true },
});

const opened = defineModel('opened', {
  type: Boolean,
  default: false,
});
</script>
